import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'


export const client = createClient({
    projectId: 'a431cel7',
    dataset: 'production',
    apiVersion: '2025-07-19',
    useCdn: false,
    token: process.env.REACT_APP_SANITY_API_TOKEN
})


const builder = imageUrlBuilder(client)
export function urlFor(source) {
    return builder.image(source)
}


